export default "__VITE_ASSET__CxdPdURE__"